<template>
  <div id="messages-list" class="messages-list-container">

    <message-template-view-sidebar
      v-if="sidebarData.id !== undefined"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      @updateMessages="fetchMessages"
      :setting="sidebarData"
    /> 

    <vs-table
      ref="table"
      noDataText="Sem dados disponíveis"
      :max-items="itemsPerPage"
      :data="filterMessages"
      search
      pagination
      @search="valueSearch"
    >
      <div
      slot="header"
      class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
              text-lg font-medium text-base text-primary border border-solid border-primary"
            @click.stop="newTemplate" 
          >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Nova Resposta Rápida</span>
          </div>
        </div>
        

        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                filterMessages.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : filterMessages.length
              }} of {{ this.filterMessages.length }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    
      <template slot="thead">
        <vs-th sort-key="identifier">Identificador</vs-th>
        <vs-th sort-key="value">Mensagem</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :title="tr.identifier" :data="data[indextr].identifier">
              <p class="product-name font-medium truncate" @click="modalToReadIdentifier(tr.identifier)"> 
                {{ foramtedMessageTemplate(tr.identifier) }}
              </p>
            </vs-td>

            <vs-td :title="tr.value" :data="data[indextr].value">
              <p class="product-name font-medium truncate overflow-hidden" @click="modalToReadMessage(tr.value)">
                {{ foramtedMessageTemplate(tr.value) }}
              </p>
            </vs-td>
            
            <vs-td class="whitespace-no-wrap">
              <feather-icon
                v-if="canSee('quick-update')"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />

              <feather-icon
                v-if="canSee('quick-update')"
                class="trash"
                icon="TrashIcon"
                svgClasses="w-5 h-5 ml-1 hover:text-danger stroke-current"
                @click.stop="confirmToDelete(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import MessageTemplateViewSidebar from '@/views/messages/MessageTemplateViewSidebar'
  import { hasPermission } from '@/utils'
  import requests from '@/http/requests/messageTemplate'

  export default {
    name: 'message-settings',
    components: {
      MessageTemplateViewSidebar
    },
    data() {
      return {
        messages: [],
        isMounted: false,
        addNewDataSidebar: true,
        sidebarData: {},
        dataSearch: '',
        itemsPerPage: 4,
        currentPage: 1,
      }
    },
    
    computed: {
      messageTemplates(){
        return this.$store.state.messageTemplates.templates
      },
      filterMessages() {
        return this.messageTemplates.filter(data => {
          if (data.identifier.toLowerCase().includes(this.dataSearch) || data.value.toLowerCase().includes(this.dataSearch)) {
            return data
          }
        })
      },
    },
    methods: {
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      valueSearch(value) {
        this.dataSearch = value;
      },
      editData(data) {
        this.sidebarData = this.$_.cloneDeep(data)
        this.toggleDataSidebar(true)
      },
      newTemplate()
      {
        this.sidebarData = {
          id: null,
          identifier: '',
          value: ''
        }
        this.toggleDataSidebar(true)
      },
      deleteData(data) {
        this.$store.dispatch('setShowLoadingOverlay', true)
        requests.delete(data.id).then(() => {
          this.$store.dispatch('setShowLoadingOverlay', false)
          this.fetchMessages();
          this.$vs.notify({
          title: "Sucesso",
          text: "Resposta rápida deletada com sucesso",
          color: "success",
        });
        }).catch(() => {
          this.$store.dispatch('setShowLoadingOverlay', false)
        })
      },
      toggleDataSidebar(val=false) {
        this.addNewDataSidebar = val
      },
      canSee(action) {
        return hasPermission(`settings-messages-${action}`)
      },
      fetchMessages() {
        this.$store.dispatch('setShowLoadingOverlay', true)
        this.$store.dispatch('messageTemplates/loadMessageTemplates')
      },
      measureTextWidth(text, fontSize) {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          context.font = `${fontSize}px Arial`;
          return context.measureText(text).width;
      },
      foramtedMessageTemplate(message) {
        return message.length >= 80 ? message.substring(0, 80) + '...' : message;
      },
      modalToReadMessage(message) {
        const maxPixelWidth = 340;
        const fontSize = 16;
        let formattedMessage = '';
        let line = '';
        for (let i = 0; i < message.length; i++) {
            line += message[i];
            const lineWidth = this.measureTextWidth(line, fontSize);
            if (lineWidth > maxPixelWidth) {
            formattedMessage += line + '\n';
            line = '';
            }
        }
            if (line.length > 0) {
                formattedMessage += line;
            }
        return this.$vs.dialog({
          color: 'primary',
          title: `Mensagem`,
          text: formattedMessage,
          acceptText: 'Fechar'
        })
      },
      modalToReadIdentifier(message) {
        const maxPixelWidth = 340;
        const fontSize = 16;
        let formattedMessage = '';
        let line = '';
        for (let i = 0; i < message.length; i++) {
            line += message[i];
            const lineWidth = this.measureTextWidth(line, fontSize);
            if (lineWidth > maxPixelWidth) {
            formattedMessage += line + '\n';
            line = '';
            }
        }
            if (line.length > 0) {
                formattedMessage += line;
            }
        return this.$vs.dialog({
          color: 'primary',
          title: `Identificador`,
          text: formattedMessage,
          acceptText: 'Fechar'
        })
      },
      confirmToDelete(data) {
        const maxIdentifierLength = 35;
        const truncatedIdentifier = data.identifier.length > maxIdentifierLength
          ? data.identifier.substring(0, maxIdentifierLength) + '...'
          : data.identifier;

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Você realmente deseja fazer isso?`,
          text: `Você deseja realmente deletar a resposta rápida ${truncatedIdentifier}?`,
          acceptText: 'Deletar',
          cancelText: 'Voltar',
          accept: () => this.deleteData(data)
        });
      }
    },
    created() {
      this.fetchMessages()
    },
    beforeRouteLeave(to, from, next) {
      if (this.addNewDataSidebar) {
        this.addNewDataSidebar = false;
        setTimeout( ()=> {
          next();
        }, 1);
      } 
      else {
        next();
      }
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>

<style lang="scss">
  #messages-list {
    .vs-con-table {
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: none;
          td{
            padding: 20px;
            padding-right: 7em;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
